var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({background: 'rgb(' + _vm.brightness + ',' + _vm.brightness + ',' + _vm.brightness + ')'}),attrs:{"id":"artboard"}},[_c('PosterP5',{style:({transform: 'scale(' + _vm.zoom + ')'})})],1)}
var staticRenderFns = []

export { render, staticRenderFns }